function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import { Link } from 'react-router';
import classnames from 'classnames';
import { Price } from 'swag-client-common/utils/price';
import Loading from 'swag-client-common/components/info/loading';
import placeholderImage from 'assets/img/placeholder.png';
import { PRODUCT_LABELS } from 'swag-common/constants/product.constants';
import { getSuperSpeedFromLS, removeSuperSpeedProductIdFromLS, setSuperSpeedProductIdInLS } from 'swag-client-common/utils/super-speed-local-storage.utils';
import { setProductColorToLS } from 'swag-client-common/utils/local-storage.util';
import PatagoniaCard from '../patagonia-card';
import { ProductFavouriteButton } from '../product-favourite-button';
import { LimitedEditionCountdownComponent as LimitedEditionCountdown } from '../../../info/limited-edition-countdown/limited-edition-countdown';
import leClasses from '../../../info/limited-edition-countdown/limited-edition-countdown.scss';
import ColorSelector from './color-selector';
import { getInitialState } from './product-card.utils';
import classes from './product-card.scss';
export class ProductCardComponent extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onProductFavouriteClick", value => {
      const {
        onProductFavouriteClick,
        item
      } = this.props;
      const data = {
        nextIsFavourite: value
      };
      if (item.childProductIds) {
        data.productAccumulatorId = item._id;
      } else {
        data.productId = item._id;
      }
      onProductFavouriteClick(data);
    });
    _defineProperty(this, "renderLabel", productLabel => {
      switch (productLabel) {
        case PRODUCT_LABELS.NEW:
          return 'NEW';
        case PRODUCT_LABELS.HOT:
          return 'HOT';
        default:
          return null;
      }
    });
    this.state = getInitialState(props);
    this.onErrorImageLoad = this.onErrorImageLoad.bind(this);
    this.onSuccessImageLoad = this.onSuccessImageLoad.bind(this);
    this.onChangeActiveShadeIndex = this.onChangeActiveShadeIndex.bind(this);
    this.onProductCardClick = this.onProductCardClick.bind(this);
  }
  onChangeActiveShadeIndex(e) {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    const {
      logo: currentLogo
    } = this.state;
    const {
      item: {
        colorFilterThumbnails
      }
    } = this.props;
    const indexAttr = e.currentTarget.getAttribute('data-index');
    const activeShadeIndex = parseInt(indexAttr, 10);
    const activeShade = colorFilterThumbnails[activeShadeIndex];
    const logo = activeShade.thumbnail;
    const color = activeShade.color;
    let isImageLoading = true;
    if (logo === currentLogo) {
      isImageLoading = false;
    }
    this.setState({
      isImageLoading,
      activeShadeIndex,
      logo,
      color
    });
  }
  onSuccessImageLoad() {
    this.setState({
      isImageLoading: false
    });
  }
  onErrorImageLoad() {
    this.setState({
      isImageLoading: false
    });
  }
  onProductCardClick() {
    const {
      onCategoryProductClick,
      item,
      showSuperSpeedIcon
    } = this.props;
    onCategoryProductClick && onCategoryProductClick(item._id);
    setProductColorToLS(this.state.color);
    if (showSuperSpeedIcon) {
      setSuperSpeedProductIdInLS(item._id);
    }
    if (!showSuperSpeedIcon && getSuperSpeedFromLS()) {
      removeSuperSpeedProductIdFromLS();
    }
  }
  render() {
    var _embellishmentMethods, _embellishmentMethods2;
    const {
      item,
      item: {
        seoSlug,
        name,
        minPrice,
        maxPrice,
        hidden,
        minQuant,
        colorFilterThumbnails,
        productLabel,
        _id,
        image,
        descriptionForWarehouse,
        embellishmentMethodsData
      },
      appliedFilter,
      isFilterPopupOpen = false,
      isFavourite,
      isFavouritesPage = false,
      isLoggedIn,
      isAccumulator,
      link,
      inStock,
      isOutOfStock,
      isLabelCentered,
      showInStockCount,
      showSuperSpeedIcon,
      showProductLabel,
      showLimitedEditionCountdown,
      limitedEdition: {
        isLimitedEdition,
        expirationDate
      },
      shouldHideFavouriteBtn
    } = this.props;
    const {
      logo,
      isImageLoading,
      activeShadeIndex,
      isSetColorFilter
    } = this.state;
    return /*#__PURE__*/React.createElement("div", {
      "data-product-id": _id,
      "data-isaccumulator": isAccumulator,
      className: classnames(classes.categoryItem, {
        [classes.markHidden]: hidden,
        [classes.openedFilter]: isFilterPopupOpen,
        [classes.isLE]: isLimitedEdition
      })
    }, /*#__PURE__*/React.createElement("a", {
      className: classes.anchor,
      id: _id
    }), /*#__PURE__*/React.createElement(Link, {
      to: link,
      className: classes.wrapper,
      onClick: this.onProductCardClick
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.container
    }, showProductLabel && /*#__PURE__*/React.createElement("div", {
      className: classnames({
        [classes.newItem]: productLabel === PRODUCT_LABELS.NEW,
        [classes.hotItem]: productLabel === PRODUCT_LABELS.HOT
      })
    }, this.renderLabel(productLabel)), showSuperSpeedIcon && /*#__PURE__*/React.createElement("div", {
      className: classes.superSpeedIcon
    }), showLimitedEditionCountdown && /*#__PURE__*/React.createElement(LimitedEditionCountdown, {
      expirationDate: new Date(expirationDate !== null && expirationDate !== void 0 ? expirationDate : 0),
      isOutOfStock: isOutOfStock,
      className: leClasses.limitedEditionCountdown
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.categoryItemImageContainer
    }, /*#__PURE__*/React.createElement("img", {
      className: classes.categoryItemImage,
      src: logo || image || placeholderImage,
      alt: `${name} - ${descriptionForWarehouse}`,
      onLoad: this.onSuccessImageLoad,
      onError: this.onErrorImageLoad
    }), isImageLoading && /*#__PURE__*/React.createElement("div", {
      className: classes.placeholder
    }, /*#__PURE__*/React.createElement(Loading, null)), isSetColorFilter && !isLimitedEdition && !isAccumulator ? /*#__PURE__*/React.createElement(ColorSelector, {
      seoSlug: seoSlug,
      colorFilterThumbnails: colorFilterThumbnails,
      activeShadeIndex: Number(activeShadeIndex),
      appliedFilter: appliedFilter,
      onChangeActiveShadeIndex: this.onChangeActiveShadeIndex
    }) : null, isLimitedEdition && /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.limitedEditionLabel, {
        [classes.limitedEditionLabelCentered]: isLabelCentered
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.label
    }, "Limited Edition"), showInStockCount && /*#__PURE__*/React.createElement("div", {
      className: classes.inStock
    }, "Only ", /*#__PURE__*/React.createElement("span", null, inStock), " in stock"))), isAccumulator ? /*#__PURE__*/React.createElement(PatagoniaCard, {
      item: item,
      isFilterPopupOpen: isFilterPopupOpen,
      className: classes.caption
    }) : /*#__PURE__*/React.createElement("div", {
      className: classes.caption
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.name
    }, name), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: classes.leftAlign
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.fromTitle
    }, "From\xA0", /*#__PURE__*/React.createElement("span", {
      className: classes.price,
      "data-price": "FromPrice"
    }, Price.formatNumber(minPrice)), /*#__PURE__*/React.createElement("span", {
      className: classes.fromTitle
    }, "\xA0to\xA0"), /*#__PURE__*/React.createElement("span", {
      className: classes.price,
      "data-price": "ToPrice"
    }, Price.formatNumber(maxPrice)))), /*#__PURE__*/React.createElement("div", {
      className: classes.rightAlign
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
      className: classes.fromTitle
    }, "Min Qty:"), /*#__PURE__*/React.createElement("span", {
      className: classes.price,
      "data-text": "Quantity"
    }, ' ', showSuperSpeedIcon ? embellishmentMethodsData === null || embellishmentMethodsData === void 0 ? void 0 : (_embellishmentMethods = embellishmentMethodsData[0]) === null || _embellishmentMethods === void 0 ? void 0 : (_embellishmentMethods2 = _embellishmentMethods.superSpeedSettings) === null || _embellishmentMethods2 === void 0 ? void 0 : _embellishmentMethods2.minQuant : minQuant))))), hidden && /*#__PURE__*/React.createElement("h3", {
      className: classes.hiddenLabel
    }, "This item is hidden"))), !shouldHideFavouriteBtn && /*#__PURE__*/React.createElement(ProductFavouriteButton, {
      disableChangingState: !isLoggedIn,
      onClick: this.onProductFavouriteClick,
      isFavourite: isFavourite,
      isFavouritesPage: isFavouritesPage
    }));
  }
}